import React, { useState } from 'react';

import Rating from '../Rating/Rating';
import css from './ReviewResult.module.css';

const ReviewResult = (props) => {
  const { review = {} } = props;
  const [showAll, setShowAll] = useState(false);
  return (
    <div className={css.Container}>
      <p className={css.Title}>
        Hi, {review.firstName}
      </p>
      <br />
      <p className={css.Intro}>
        Thank you for taking your time to give us your feedback
      </p>
      <Rating rating={review.rating} display />
      <div onClick={() => setShowAll(!showAll)} style={showAll ? {} : { WebkitLineClamp: 2, display: '-webkit-box', WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
        <p>
          <i>
            "{review.feedback}"
          </i>
        </p>
      </div>
    </div >
  )
}
export default ReviewResult;
